import { Component, inject } from '@angular/core';
import { FormStateService, FormConfig } from '../../services';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalizePipe } from '../../pipes';

@Component({
  selector: 'rc-app-submit-bar',
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslateModule, CapitalizePipe],
  templateUrl: './app-submit-bar.component.html',
  styleUrl: './app-submit-bar.component.scss',
})
export class AppSubmitBarComponent {
  formState = inject(FormStateService);
  activeForm = this.formState.getActiveForm();

  handleCancel(config: FormConfig) {
    config.onCancel();
  }
}
